(function () {
  var header = document.querySelector('.innza-header');
  var toggle = document.querySelector('.innza-header__toggle');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-innza-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-innza-main-image]');
      var next = thumb.getAttribute('data-full');
      if (main && next) {
        main.setAttribute('src', next);
      }
    });
  });
})();
